import React, { Component } from 'react';
import { Alert } from 'reactstrap';
import ReactTooltip from 'react-tooltip';

class OitTaskTable extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      ...prevState,
      filteredTaskResponses: nextProps.taskResponses,
    };
  }

  constructor(props) {
    super(props);
    this.state = {
      filteredTaskResponses: this.props.taskResponses || [],
      filterByTaskPrompt: '',
      filterByTaskGroup: '',
      sort: {
        prop: '',
        direction: '',
      },
    };
  }

  // ----------------------
  // Methods
  // ----------------------

  filterByTaskGroup(taskGroupGuid) {
    const filteredTaskResponses = !taskGroupGuid
      ? this.props.tasks
      : this.props.tasks.filter((task) => {
        if (taskGroupGuid === 'Unassigned' && task.taskGroup === null) {
          return true;
        }
        return !task.taskGroup ? false : task.taskGroup.taskGroupGuid === taskGroupGuid;
      });
    this.setState({
      filteredTaskResponses,
      filterByTaskPrompt: '',
      filterByTaskGroup: taskGroupGuid,
    });
  }

  filterByTaskPrompt(characters) {
    const filteredTaskResponses = this.props.tasks.filter((task) => {
      return task.prompt.toLowerCase().includes(characters.toLowerCase());
    });
    this.setState({
      filteredTaskResponses,
      filterByTaskPrompt: characters,
      filterByTaskGroup: '',
    });
  }

  sortByProperty(property) {
    if (property === this.state.sort.prop) {
      if (this.state.sort.direction === 'desc') {
        this.setState({
          sort: {
            prop: property,
            direction: 'asc',
          },
        });
      } else {
        this.setState({
          sort: {
            prop: property,
            direction: 'desc',
          },
        });
      }
    } else {
      this.setState({
        sort: {
          prop: property,
          direction: 'asc',
        },
      });
    }
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <div className="tasks-table">
        <form className="table-filters">
          <div className="form-group">
            <label htmlFor="filterByTaskGroup">Filter by Task Group</label>
            <select
              className="form-control"
              id="filterByTaskGroup"
              onChange={event => this.filterByTaskGroup(event.target.value)}
              name="filterByTaskGroup"
              value={this.state.filterByTaskGroup}
            >
              <option value="">All</option>
              <option value={null}>Unassigned</option>
              {this.props.taskGroupsOptions &&
                this.props.taskGroupsOptions.map((option, index) => (
                  <option key={index.toString()} value={option.guid}>
                    {option.name}
                  </option>
                ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="filterByTaskPrompt">Search by Task Prompt</label>
            <input
              className="form-control"
              id="filterByTaskPrompt"
              name="filterByTaskPrompt"
              onChange={event => this.filterByTaskPrompt(event.target.value)}
              type="text"
              value={this.state.filterByTaskPrompt}
              placeholder="Search by Task Prompt"
            />
          </div>
        </form>

        {!this.state.filteredTaskResponses.length ? (
          <Alert color="primary">No Task Responses for selected filters</Alert>
        ) : (
          <table className="table table-stripped">
            <thead>
              <tr>
                <th onClick={() => this.sortByProperty('name')}>
                  <div className="header">
                    <span>Prompt </span>
                  </div>
                </th>
                <th onClick={() => this.sortByProperty('catergory')}>
                  <div className="header">
                    <span>Task Group </span>
                    <div className="filterActions">
                      <i className="fa fa-angle-up" />
                      <i className="fa fa-angle-down" />
                    </div>
                  </div>
                </th>
                <th>
                  <div className="header">
                    <span>Actions </span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {this.state.filteredTaskResponses.map((task, index) => {
                return (
                  <tr key={index.toString()}>
                    <td>{task.prompt}</td>
                    <td>{task.taskGroup ? task.taskGroup.name : 'None'}</td>
                    <td className="td-actions">
                      <ReactTooltip
                        place="top"
                        className="customTheme"
                        effect="solid"
                      />
                      <button
                        data-tip="Edit task"
                        className="button default small"
                        onClick={() => this.props.onEdit(task.guid)}
                      >
                        <i className="fa fa-edit" />
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    );
  }
}

export default OitTaskTable;
